<template>
  <div class="flex flex-wrap gap-6 justify-center px-14 py-8 w-full">
    <div
      v-for="(island, index) in islandList"
      :key="island.id"
      class="relative"
      :class="[
        island.image == 0 ? 'w-full' : 'w-1/2-gap-6',
        island.image == 2
          ? '-mt-6'
          : island.image == 1
            ? '-mt-3'
            : island.image == 4
              ? 'mt-3'
              : island.image == 3
                ? '-mt-8'
                : island.image == 5
                  ? '-mt-14'
                  : ''
      ]"
    >
      <button @click="openIslandDrawer(island)" class="w-full h-full">
        <img
          :src="getImage(island)"
          class="w-full h-full object-contain relative"
          :class="!island.isLocked && !island.isCompleted ? 'bounce' : ''"
        />
      </button>
      <img
        v-if="parseInt(island.image) === 0"
        src="../assets/images/journey/journey-ship-1.svg"
        class="absolute top-[50%] -right-4 w-[100px] boat-1"
      />
      <img
        v-if="parseInt(island.image) === 4 && index % 2 !== 1"
        src="../assets/images/journey/journey-ship-1.svg"
        class="absolute top-[30%] -right-[50px] w-[90px] boat-2"
      />
      <img
        v-if="parseInt(island.image) === 5 && index % 2 !== 0"
        src="../assets/images/journey/journey-ship-2.svg"
        class="absolute -bottom-6 -left-8 w-[80px] boat-3"
      />
    </div>
  </div>
</template>
<script setup>
import { onMounted, ref } from 'vue'
import { openBottomDrawer } from '@/composables/bottomdrawer'
import IslandDrawer from '@/components/drawers/IslandDrawer.vue'
import { useConstantStore } from '@/stores/constant'

const constantStore = useConstantStore()
const islandList = ref([])

const openIslandDrawer = (item) => {
  openBottomDrawer(IslandDrawer, {
    props: { island: item },
    emits: {},
  })
}

const getImage = (item) => {
  console.log(item)
  const index = parseInt(item.image) + 1
  var imageUrl
  if (item.isCompleted) {
    imageUrl = new URL(
      `../assets/images/journey/journey-island-${index}-completed.svg`,
      import.meta.url
    ).href
  } else if (item.isLocked) {
    imageUrl = new URL(
      `../assets/images/journey/journey-island-${index}-locked.svg`,
      import.meta.url
    ).href
  } else {
    imageUrl = new URL(`../assets/images/journey/journey-island-${index}.svg`, import.meta.url).href
  }
  return imageUrl
}

onMounted(() => {
  console.log(constantStore.islands)
  islandList.value = constantStore.islands
})
</script>

<style>
.bounce {
  animation: bounce 0.5s;
  animation-direction: alternate;
  animation-timing-function: cubic-bezier(0.5, 0.05, 1, 0.5);
  animation-iteration-count: infinite;
}

@keyframes bounce {
  from {
    transform: translate3d(0, 0, 0);
  }

  to {
    transform: translate3d(0, 3px, 0);
  }
}

.boat-1 {
  animation: boat-1 2s linear infinite;
}

@keyframes boat-1 {
  0% {
    transform: rotate(0);
  }

  50% {
    transform: rotate(-6deg);
  }

  100% {
    transform: rotate(0);
  }
}
.boat-2 {
  animation: boat-2 4s linear infinite;
}

@keyframes boat-2 {
  0% {
    transform: rotate(0);
  }

  50% {
    transform: rotate(-3deg);
  }

  100% {
    transform: rotate(0);
  }
}
.boat-3 {
  animation: boat-3 2s linear infinite;
}

@keyframes boat-3 {
  0% {
    transform: rotate(0);
  }

  50% {
    transform: rotate(4deg);
  }

  100% {
    transform: rotate(0);
  }
}
</style>
